import React from "react";
// ANT DESIGN COMPONENTS
import { Collapse } from "antd";
import CdoOpcMapping from "./CdoOpcMapping";
// INTERFACES
import { OpcMappingsInterface } from "../../../../../interfaces/AdapterCdoOpc.interface";

export default function CdoOpcMappingPage({
  setValue,
  title,
  opcMapping,
}: {
  setValue: (newValue: OpcMappingsInterface) => void;
  title: string;
  opcMapping: OpcMappingsInterface;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { Panel } = Collapse;

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <Collapse>
        <Panel header={title} key="1">
          <CdoOpcMapping
            setValue={setValue}
            opcMapping={{
              opc_cmd_to_msg: opcMapping.opc_cmd_to_msg || [],
              msg_to_opc_cmd: opcMapping.msg_to_opc_cmd || [],
              opc_cmd_to_sequence: opcMapping.opc_cmd_to_sequence || [],
            }}
          />
        </Panel>
      </Collapse>
      <br />
    </div>
  );
}
